<div class="conditions-list">
  @for (condition of conditions; track condition.conditionId) {
    <mpctm-condition-list-item [condition]="condition" />
  }
</div>
